import React from 'react';
import styled from 'styled-components';

type Props = {
  value?: {
    source: string;
    target: string;
  };
};

const TargetSourceRenderer: React.FC<Props> = ({ value }) => {
  if (!value) {
    return null;
  }

  return (
    <ItemContainer>
      <TargetText dangerouslySetInnerHTML={{ __html: value.target || '' }} />
      <SourceText>{value.source || ''}</SourceText>
    </ItemContainer>
  );
};

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 0;
`;

const TargetText = styled.div`
  color: #333;
  line-height: 1.3;
`;

const SourceText = styled.div`
  color: #666;
  line-height: 1.3;
`;

export default TargetSourceRenderer;
